import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class RmRackIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    rmRackId: number;
    @ApiProperty()
    saleOrderId:number;
}